import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Select from "react-select";
import OptionScr from "./OptionScr";
import OptionAnanlysis from "./OptionAnanlysis";
import OptionChainData from "./OptionChainData";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant="caption">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  setSelect: {
    width: "150px",
    display: "inline-block",
    marginLeft: "10px",
  },
  floatRight: {
    float: "right",
  },
  blueBg: {
    backgroundColor: "#1b95e0",
  },
  iconp: {
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: "-10px",
    right: "10px",
    fontSize: "30px",
    cursor: "pointer",
    color: "#007bff",
    fontWeight: "bold",
  },
}));

export default function FANDODATA(props) {
  const globaldata = props?.fnoData;
  const showIndicators = props.showIndicators;
  const classes = useStyles();
  const symbol = props?.symbol;
  const [value, setValue] = React.useState(0);
  const [futureData, setFutureData] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getExpiryDate = (event) => {
    RestService.gethFuturelysisData(
      function (res) {
        const response = JSON.parse(res);
        setFutureData(response.data);
      },
      symbol,
      mobile,
      web_token,
      event.value
    );
  };

  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  const TableRowData = ({ item }) => {
    const [isshowData, setIsshowData] = useState(false);
    const handleChangeEvent = () => {
      setIsshowData(!isshowData);
    };
    if (!item) {
      return null;
    }
    return (
      <>
        <tr>
          <td>{item.close}</td>
          <td>{item.oiper}</td>
          <td>{item.volperct}</td>
          <td className={item.cchg >= 0 ? "green_color" : "red_color"}>
            {item.cchg}{" "}
          </td>
          <td>{item.expiry_date} </td>
          <td>{item.contracts} </td>
          <td className={`${item.colorClass} ${classes.iconp}`}>
            {item.foptionchainSignal}

            <div className={classes.icon}>
              <i
                className={isshowData ? "fa fa-angle-up" : "fa fa-angle-down"}
                onClick={handleChangeEvent}
              ></i>
            </div>
          </td>
        </tr>
        {isshowData === true && (
          <tr>
            <td colSpan="7">
              <div className="row">
                <div className="col-3 boldfont">Open</div>
                <div className="col-3">{item.open}</div>
                <div className="col-3 boldfont">Contracts</div>
                <div className="col-3">{item.contracts}</div>
              </div>
              <div className="row">
                <div className="col-3 boldfont">High</div>
                <div className="col-3">{item.high}</div>
                <div className="col-3 boldfont">%VOL</div>
                <div className="col-3">{item.volperct}</div>
              </div>
              <div className="row">
                <div className="col-3 boldfont">Low</div>
                <div className="col-3">{item.low}</div>
                <div className="col-3 boldfont">Value(Lakh)</div>
                <div className="col-3">{item.val_inlakh}</div>
              </div>
              <div className="row">
                <div className="col-3 boldfont">Close</div>
                <div className="col-3">{item.close}</div>
                <div className="col-3 boldfont">OI Chg</div>
                <div className="col-3">{item.chg_in_ol}</div>
              </div>
              <div className="row">
                <div className="col-3 boldfont">Settle Price</div>
                <div className="col-3">{item.settle_pr}</div>
                <div className="col-3 boldfont">%Chg</div>
                <div className="col-3">{item.cchg}</div>
              </div>
              <div className="row">
                <div className="col-3 boldfont">OI</div>
                <div className="col-3">{item.open_int}</div>
                <div className="col-3 boldfont">
                  <span className={item.colorClass}>
                    {item.foptionchainSignal}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        )}
      </>
    );
  };

  return (
    <>
      <div className={classes.root}>
        {showIndicators === 0 && (
          <div className="row mt-4">
            <div className="col-12 text-center mt-4 mb-4">
              <Link
                to="/subscription"
                target="_blank"
                className="btn btn-primary"
              >
                To access All scan service make payment and enjoy data
              </Link>
            </div>
          </div>
        )}
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="Future" {...a11yProps(0)} />
            <Tab label="Option Screener" {...a11yProps(1)} />
            <Tab label="Option Analysis" {...a11yProps(2)} />
            <Tab label="Option Chain" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel className="customtabpanel" value={value} index={0}>
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead>
                <tr>
                  <th>Close</th>
                  <th>%OI</th>
                  <th>%Vol</th>
                  <th>%CHG</th>
                  <th>Expiry Date</th>
                  <th>Vol</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {globaldata?.getHistoricalData?.map((item, key) => (
                  <TableRowData key={`fnadO${key}`} item={item} />
                ))}
              </tbody>
            </table>
          </div>
          <table className={`${classes.blueBg} table_content mt-2 mb-4`}>
            <tbody>
              <tr className="table_rows  ">
                <td className="boldfont font-white">Future Historical Data</td>
                <td className={classes.floatRight}>
                  {globaldata.allDate && (
                    <Select
                      onChange={getExpiryDate}
                      options={globaldata.allDate ? globaldata.allDate : []}
                      name="expiry_date"
                      className={classes.setSelect + " select-option"}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          {futureData?.getstockPrice && (
            <div className="table-responsive">
              <table className="table table-bordered ">
                <thead>
                  <tr className="header-row">
                    <th className="indexname">Date</th>
                    <th className="indexname">Close</th>
                    <th className="indexname">%OI</th>
                    <th className="indexname">%CHG</th>
                  </tr>
                </thead>
                <tbody>
                  {futureData?.getstockPrice?.map((item, key) => (
                    <tr className="table_rows" key={`fandoData${key}`}>
                      <td className="indexname">{item.time_stamp}</td>
                      <td className="indexname symbol-text">{item.close}</td>
                      <td className={item.oiper < 0 ? "redTxts" : "greenTxts"}>
                        {item.oiper}
                      </td>
                      <td className={item.cchg < 0 ? "redTxts" : "greenTxts"}>
                        {item.cchg}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </TabPanel>
        <TabPanel className="customtabpanel" value={value} index={1}>
          {globaldata.allDate && (
            <OptionScr allDate={globaldata.allDate} symbol={symbol} />
          )}
        </TabPanel>
        <TabPanel
          className="customtabpanel customTablePanel"
          value={value}
          index={2}
        >
          {globaldata.allDate && (
            <OptionAnanlysis allDate={globaldata.allDate} symbol={symbol} />
          )}
        </TabPanel>
        <TabPanel
          className="customtabpanel customTablePanel"
          value={value}
          index={3}
        >
          <OptionChainData symbol={symbol} />
        </TabPanel>
      </div>
    </>
  );
}
